export const COUNTERFEIT_REPORT = "counterfeitReport";